var map = {
	"./exitfullscreen.svg": "1f03",
	"./fullscreen.svg": "9921",
	"./fullscreensmall.svg": "a6b7",
	"./pause.svg": "d46e",
	"./play.svg": "fb4f",
	"./replay.svg": "1b4a",
	"./voice.svg": "3f0e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";